import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";

const ConfirmationModal = ({
  show,
  onHide,
  text,
  onConfirm
}) => {

  return (
    <Modal show={show} className="confirmation_modal">
    <Modal.Header>
      <Modal.Title>Confirmation</Modal.Title>
    </Modal.Header>
    <Modal.Body>{text}</Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>
        Cancel
      </Button>
      <Button variant="primary" onClick={onConfirm}>
        Confirm
      </Button>
    </Modal.Footer>
  </Modal>
  );
};

export default ConfirmationModal;
